"use strict";
/* ========================================================================
    Module: Util
 ========================================================================== */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCssPropertyValue = void 0;
/*
 * Get CSS property value
 */
const getCssPropertyValue = (name) => {
    let value = getComputedStyle(document.documentElement).getPropertyValue(name);
    return value;
};
exports.getCssPropertyValue = getCssPropertyValue;
